import React from 'react';
import { View, Preloader, l10n, IDate, Sync } from '@ab/components';
import { connect } from 'react-redux';
import { set as _confSet, api, get } from '../../../config';
import uaLang from '../../../l10n/ua.json';
import { lang } from '../../../actions'

class Localization extends View {
    templates = {
        [this.uiStates.INITIAL]: <Preloader className="center" />,
        [this.uiStates.STANDBY]: <Preloader className="center" />,
        [this.uiStates.INTERACTIVE]: function template() {
            return this.props.children;
        },
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
        };

        _confSet('LANG', props.lang);
    }

    async componentWillReady(resolve) {
        await this.uiStandBy();

        this._loadDefaultLocale();
        this._loadLocale();
        this._setIDateLocale();
        this._setPageTitle();

        resolve();
    }

    async componentDidUpdate(prevProps) {
        const { lang, pageTitle } = this.props;

        if (lang && prevProps.lang !== lang) {
            await this.uiStandBy();
            this._loadLocale(lang);

            try {
                await this._setLocale();
                this._setIDateLocale();
                this._setPageTitle();

                const model = this.getModel();

                model.set({ lang });
                _confSet('LANG', lang);
                this.uiInteractive();
            } catch (e) {
                /* eslint-env node */
                if (process?.env.NODE_ENV !== 'production') {
                    window.console.error(e);
                }
            }
        } else if (pageTitle && pageTitle !== prevProps.pageTitle) {
            this._setPageTitle();
        }
    }

    _loadDefaultLocale() {
        l10n.setDefaultLocale(uaLang);
        this.props.dispatch(lang('uk'));
    }

    _loadLocale(lang = this.props.lang) {
        l10n.setLocale(uaLang);
    }

    _setLocale = (lang = this.props.lang) => {
        const Engine = Sync.getEngine('xhr');

        return new Engine({
            url: api('API_SETTINGS'),
            contentType: 'application/json',
        }).post({
            data: {
                action: 'changeLang',
                language: 'uk',
                xref: get('XREF'),
            },
        });
    };

    _setPageTitle(title = this.props.pageTitle) {
        document.querySelector('head title').innerHTML = this.l10n(title);
    }

    _setIDateLocale() {
        // set inner prototype properties
        IDate.prototype._monthNames = [
            this.l10n('DATE_MONTH_1'),
            this.l10n('DATE_MONTH_2'),
            this.l10n('DATE_MONTH_3'),
            this.l10n('DATE_MONTH_4'),
            this.l10n('DATE_MONTH_5'),
            this.l10n('DATE_MONTH_6'),
            this.l10n('DATE_MONTH_7'),
            this.l10n('DATE_MONTH_8'),
            this.l10n('DATE_MONTH_9'),
            this.l10n('DATE_MONTH_10'),
            this.l10n('DATE_MONTH_11'),
            this.l10n('DATE_MONTH_12'),
        ];
        IDate.prototype._monthNamesShort = [
            this.l10n('DATE_SHORT_MONTH_1'),
            this.l10n('DATE_SHORT_MONTH_2'),
            this.l10n('DATE_SHORT_MONTH_3'),
            this.l10n('DATE_SHORT_MONTH_4'),
            this.l10n('DATE_SHORT_MONTH_5'),
            this.l10n('DATE_SHORT_MONTH_6'),
            this.l10n('DATE_SHORT_MONTH_7'),
            this.l10n('DATE_SHORT_MONTH_8'),
            this.l10n('DATE_SHORT_MONTH_9'),
            this.l10n('DATE_SHORT_MONTH_10'),
            this.l10n('DATE_SHORT_MONTH_11'),
            this.l10n('DATE_SHORT_MONTH_12'),
        ];
        IDate.prototype._monthNamesWithDate = [
            this.l10n('DATE_GENITIVE_MONTH_1'),
            this.l10n('DATE_GENITIVE_MONTH_2'),
            this.l10n('DATE_GENITIVE_MONTH_3'),
            this.l10n('DATE_GENITIVE_MONTH_4'),
            this.l10n('DATE_GENITIVE_MONTH_5'),
            this.l10n('DATE_GENITIVE_MONTH_6'),
            this.l10n('DATE_GENITIVE_MONTH_7'),
            this.l10n('DATE_GENITIVE_MONTH_8'),
            this.l10n('DATE_GENITIVE_MONTH_9'),
            this.l10n('DATE_GENITIVE_MONTH_10'),
            this.l10n('DATE_GENITIVE_MONTH_11'),
            this.l10n('DATE_GENITIVE_MONTH_12'),
        ];
        IDate.prototype._dayOfWeekShort = [
            '',
            this.l10n('DATE_DAY_SHORT_1'),
            this.l10n('DATE_DAY_SHORT_2'),
            this.l10n('DATE_DAY_SHORT_3'),
            this.l10n('DATE_DAY_SHORT_4'),
            this.l10n('DATE_DAY_SHORT_5'),
            this.l10n('DATE_DAY_SHORT_6'),
            this.l10n('DATE_DAY_SHORT_7'),
        ];
        IDate.prototype._dayOfWeek = [
            '',
            this.l10n('DATE_DAY_1'),
            this.l10n('DATE_DAY_2'),
            this.l10n('DATE_DAY_3'),
            this.l10n('DATE_DAY_4'),
            this.l10n('DATE_DAY_5'),
            this.l10n('DATE_DAY_6'),
            this.l10n('DATE_DAY_7'),
        ];
    }

    static displayName = 'Application.views.Localization';
}

const onStateChange = state => {
    return {
        lang: state.lang,
        pageTitle: state.pageTitle,
    };
};

export default connect(onStateChange)(Localization);
